// src/index.ts
function isSuccessResponse(response) {
  return response.success === true;
}
function isErrorResponse(response) {
  return response.success === false;
}
export {
  isErrorResponse,
  isSuccessResponse
};
